import type { LucideIcon } from 'lucide-react'
import { ClipboardList } from 'lucide-react'
import { PublicHeader } from '../../../components/Navigation/PublicHeader'
import { AppLayout, AppContent } from '../../../styles/AppStyles'
import { COLORS } from '../../../styles/theme'
import { SurveyBrandFooter } from './SurveyBrandFooter'
import {
  BrandRow,
  Content,
  Header,
  Page,
  StateBody,
  StateCard,
  StateTitle,
} from './SurveyParticipantPageStyles'

export interface SurveyParticipantStateViewProps {
  /** Icon shown above the title (lucide). */
  icon: LucideIcon
  iconColor?: string
  title: string
  body: string
}

/**
 * Shared chrome for terminal states on the participant page (thank-you,
 * closed survey, etc.) — keeps the layout, brand row, and footer consistent.
 */
export function SurveyParticipantStateView({
  icon: Icon,
  iconColor,
  title,
  body,
}: SurveyParticipantStateViewProps) {
  return (
    <AppLayout>
      <PublicHeader showReadOnlyIndicator={false} />
      <AppContent>
        <Page>
          <Content>
            <Header>
              <BrandRow>
                <ClipboardList size={14} />
                Validation Survey
              </BrandRow>
            </Header>
            <StateCard>
              <Icon size={40} color={iconColor ?? COLORS.primary} strokeWidth={1.5} />
              <StateTitle>{title}</StateTitle>
              <StateBody>{body}</StateBody>
            </StateCard>
            <SurveyBrandFooter />
          </Content>
        </Page>
      </AppContent>
    </AppLayout>
  )
}
